




import { Vue, Component, Prop } from 'vue-property-decorator';
import { Chart } from 'highcharts-vue';
import moment from 'moment';

@Component({
  components: {
    highcharts: Chart,
  },
})
export default class NewDownlineChart extends Vue {
  @Prop() readonly series: any;

  @Prop() readonly title!: string;

  chartOptions: any = {
    chart: {
      type: 'column',
    },
    title: {
      text: this.title,
    },
    subtitle: {
      text: `In ${moment().format('MMM, YYYY')}`,
    },
    yAxis: {
      title: {
        text: 'Amount',
      },
    },
    xAxis: {
      title: {
        text: `Date in ${moment().format('MMM, YYYY')}`,
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        dataLabels: {
          enabled: true,
        },
      },
      series: {
        pointStart: 1,
      },
    },
  };

  created() {
    const { series } = this;
    this.chartOptions = { ...this.chartOptions, series };
  }
}
